import { SearchInput, Switch } from "@repo/ui";

type Props = {
  showAll: boolean;
  onShowAllChange: (value: boolean) => void;
  searchQuery: string;
  onSearchQueryChange: (value: string) => void;
  onSearchFocus: () => void;
};

export const TaskManagerToolbar = ({
  showAll,
  onShowAllChange,
  searchQuery,
  onSearchQueryChange,
  onSearchFocus,
}: Props) => {
  return (
    <div className="mb-6 flex items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        <label className="text-gxe-primary text-sm font-bold" htmlFor="show-all-switch">
          Show all
        </label>
        <Switch
          id="show-all-switch"
          checked={showAll}
          onCheckedChange={onShowAllChange}
          className="data-[state=checked]:bg-gxe-primary bg-gray-300"
        />
      </div>
      <SearchInput
        value={searchQuery}
        onChange={onSearchQueryChange}
        placeholder="Search tasks..."
        className="max-w-md bg-white"
        onFocus={onSearchFocus}
        clearable
      />
    </div>
  );
};
